const ZIP_CODE_REGEX = /^\d{5}$/;

const isZipCode = (val) => ZIP_CODE_REGEX.test(val);

export default isZipCode;
